// extracted by mini-css-extract-plugin
export default {"recipeRow":"G53b56c","recipeImage":"Gdba11e","recipeItem":"G1dfce3"};